// import React, { Component } from "react";
import BasePage from "../../base/BasePage";
import MainPagePresenter from "../../pages/main/MainPagePresenter";
import "./header.css";

class NavBar extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter();
    this.state = {};
  }

  render() {
    return (
      <>
        <nav
          className={`navbar navbar-expand-lg navbar-light shadow-sm`}
          style={{
            zoom: "1.1",
            width: "100%",
            position: "fixed",
            top: 0,
            height: "auto",
            zIndex: 1000,
          }}
        >
          <div className="d-flex">
            <img
              src={`${process.env.PUBLIC_URL}/BIR.png`}
              alt="Logo"
              className="BI-Logo"
            />
            <div
              className="d-flex"
              style={{
                paddingLeft: "10px",
                lineHeight: "1",
                fontSize: "13px",
                fontWeight: "bold",
                color: "#1d4d8b",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <p style={{ margin: "0" }}>Republic of the Philippines</p>
              <p style={{ margin: "0" }}>Bureau of Immigration</p>
              <p style={{ margin: "0" }}>
                Patriotism
                <i className="bi bi-dot"></i> Integrity
                <i className="bi bi-dot"></i>Professionalism
              </p>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default NavBar;
